<template>
  <v-container class="page-content px-5" style="width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        flat
    >
      <v-text-field
          outlined
          clearable
          dense
          single-line
          :disabled="isLoading"
          v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData" @click:clear="clearSearchData" >
      </v-text-field>
      <v-select
          v-if="$vuetify.breakpoint.mdAndUp"
          v-model="pagination.filters.order_type"
          label="Тип пропуска"
          class="pt-7 pr-1 pl-2"
          style="padding-bottom: 2px"
          outlined
          dense
          single-line
          flat
          clearable
          :disabled="isLoading"
          :items="choices.order_type"
      >
      </v-select>
      <v-select
          v-if="$vuetify.breakpoint.mdAndUp"
          v-model="pagination.filters.order_status"
          label="Статус заявки"
          class="pt-7 px-1"
          style="padding-bottom: 2px"
          outlined
          dense
          single-line
          flat
          clearable
          :disabled="isLoading"
          :items="choices.order_status"
      >
      </v-select>
      <v-spacer></v-spacer>
      <div>
        <v-btn
          icon
          class="mr-0 dark-primary"
          @click="dialog_info = true"
        >
          <v-icon>info</v-icon>
        </v-btn>
        <v-dialog
          v-model="dialog_info"
          width="500"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Ограничение заявок
            </v-card-title>
              <v-alert class="rounded-lg ma-2 " color="info" outlined style="text-align: left">
                <span>
                  Обращаем ваше внимание на ограничение, связанное с количеством создаваемых заявок. В течение 30 дней вам будет разрешено:
                </span> <br>
                Разовых пропусков: {{ limits.max_user_order }} <br>
                Автомобильных разовых пропусков: {{ limits.max_auto_one_time }} <br>
                Автомобильных временных пропусков: {{ limits.max_auto_constant }} <br>
              </v-alert>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="dialog_info = false"
              >
                Закрыть
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <v-btn
          v-if="$vuetify.breakpoint.smAndDown"
          icon
          class="mr-0 dark-primary"
          @click="newOrder"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn
          icon
          class="mr-0 dark-primary"
          @click="show = !show"
      >
        <v-icon>{{ show ? 'expand_less' : 'expand_more' }}</v-icon>
      </v-btn>
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp">
        <v-btn
            text
            @click="newOrder"
            class="rounded-tr-lg dark-primary"
        >
          Добавить заявку
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-slide-y-transition>
      <v-toolbar color="#DADADA" v-if="show" elevation="0" :height="extensionHeight">
        <v-row no-gutters>
          <v-col cols="6" v-if="$vuetify.breakpoint.smAndDown" class="pr-3 mt-4">
            <v-select
                v-model="pagination.filters.order_type"
                label="Тип пропуска"
                style="padding-bottom: 2px"
                outlined
                dense
                clearable
                :disabled="isLoading"
                :items="choices.order_type"
                hide-details
                single-line
            >
            </v-select>
          </v-col>
          <v-col cols="6" v-if="$vuetify.breakpoint.smAndDown" class="mt-4">
            <v-select
                v-model="pagination.filters.order_status"
                label="Статус заявки"
                style="padding-bottom: 2px"
                clearable
                outlined
                dense
                :disabled="isLoading"
                :items="choices.order_status"
                hide-details
                single-line
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="mt-md-6 mt-3 pr-md-3">
            <v-text-field
                v-model="pagination.filters.start_date" type="date"
                dense outlined
                label="Дата начала действия пропуска" clearable
                :disabled="isLoading"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="mt-md-6 mt-n3">
            <v-text-field
                v-model="pagination.filters.end_date" type="date"
                outlined dense
                label="Дата окончания действия пропуска" clearable
                :disabled="isLoading"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-toolbar>
    </v-slide-y-transition>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        multi-sort
        :options.sync="options"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-1 rounded-b-lg"
    >
      <template v-slot:item.through_number="props">
        <span v-if="props.item.through_number === null" style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">Отсутствует</span>
        <span v-else style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">{{props.item.through_number}}</span>
      </template>
      <template v-slot:item.responsible="{ item }">
        <span>{{ item.responsible.fio }}</span>
      </template>
      <template v-slot:item.visitors="{ item }">
        <span v-if="String(item.order_type) === 'Массовый'">
          <v-icon>groups</v-icon>
        </span>
        <span v-else>{{ item.visitors }}</span>
      </template>
      <template v-slot:item.order_type="{ item }">
        <span>
          <v-icon
            class="mr-2"
          >
            {{ orderTypeIcons(item) }}
          </v-icon>
          {{ item.order_type }}
        </span>
      </template>
      <template v-slot:item.status="{ item }">
        <span>{{ order_status(item) }}
<!--          <v-tooltip bottom  v-if="item.automate_annul">-->
<!--            <template v-slot:activator="{ on, attrs }">-->
<!--              <v-icon-->
<!--                  small-->
<!--                  class="pb-1 medium-primary"-->
<!--                  v-bind="attrs"-->
<!--                  v-on="on"-->
<!--              >-->
<!--                hdr_auto-->
<!--              </v-icon>-->
<!--            </template>-->
<!--            <span>Аннулирована автоматически</span>-->
<!--          </v-tooltip>-->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  small
                  class="pb-1 medium-primary"
                  v-bind="attrs"
                  v-on="on"
              >
                info
              </v-icon>
            </template>
            <span>{{ orderTextStatus(item) }}</span>
          </v-tooltip>
        </span>
      </template>
      <template v-slot:item.last_update="{ item }">
        <span>{{ displayDate(item.last_update, true) }}</span>
      </template>
      <template v-slot:item.start_date="{ item }">
        <span>{{ displayDate(item.start_date) }}</span>
      </template>
      <template v-slot:item.end_date="{ item }">
        <span>{{ displayDate(item.end_date) }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom v-if="item.is_agreed === null && !item.is_annul || !item.is_annul && item.allowed_withdrawn && !item.is_withdrawn || item.allowed_annul && !item.is_annul">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="mr-2"
                @click="changeOrderStatus(item)"
                v-bind="attrs"
                v-on="on"
            >
              {{ checkEditFlag(item).icon }}
            </v-icon>
          </template>
          <span>{{ checkEditFlag(item).text }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.through_number !== null">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="mr-2"
                @click="copyOrder(item)"
                v-bind="attrs"
                v-on="on"
            >
              content_copy
            </v-icon>
          </template>
          <span>Копировать заявку</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.is_agreed === null && item.is_formalized === false">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="mr-2"
                @click="editOrder(item)"
                v-bind="attrs"
                v-on="on"
            >
              edit
            </v-icon>
          </template>
          <span>Редактировать заявку</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.is_agreed === null && item.is_formalized === false">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="deleteOrder(item)"
                v-bind="attrs"
                v-on="on"
            >
              delete
            </v-icon>
          </template>
          <span>Удалить заявку</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="updateData"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
    <OrdersDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :order-data="order_data"
        @close="closeEditDialog"
    ></OrdersDialog>
    <ApplyDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить данную заявку?`"
        @close="closeDeleteDialog"
    ></ApplyDialog>
    <ApplyDialog
        v-if="dialog_copy"
        :opened="dialog_copy"
        :get-text="() => `Вы уверены, что хотите скопировать данную заявку?`"
        @close="closeCopyDialog"
    ></ApplyDialog>
    <ApplyDialog
        v-if="dialog_status"
        :opened="dialog_status"
        :get-text="() => dialog_status_text"
        @close="closeStatusDialog"
    ></ApplyDialog>

    <v-dialog
        v-model="error_text.error"
        transition="dialog-top-transition"
        max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5 red lighten-2 mt-n2">
          <span class="white--text">Ошибка</span>
        </v-card-title>
        <v-card-text class="subtitle-1 mt-4 text--primary text-left">
          {{ error_text.text }}
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="error_text.error = false"
          >Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-if="isNotFormedOrders"
        v-model="not_formed_orders"
        transition="dialog-top-transition"
        max-width="500"
    >
      <v-card class="rounded-lg">
        <v-card-title class="rounded-t-lg text-h5 style-color-main-gray lighten-1">
          <span class="mt-n2">Информация</span>
        </v-card-title>
        <v-card-text class="subtitle-1 mt-4 text--primary text-left">
          <p> Уважаемый пользователь, у вас есть неотправленные заявки.
            Пожалуйста, убедитесь, что все нужные заявки отправлены на согласование.</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="closeNotFormedOrdersDialog"
          >Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import OrdersDialog from "../components/OrdersEditDialog";
import ApplyDialog from "@/modules/core/components/ApplyDialog";
import names from "@/modules/representative/routers/names";
import {displayDate} from "@/helper";
import representative from "@/urls/roles/representative";
import names_core from "@/modules/core/routers/names";

export default {
  name: "RepresentativeOrdersList",
  components: {
    OrdersDialog,
    ApplyDialog
  },
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список заявок",
      show: false,
      dialog_info: false,
      dialog_add_edit: false,
      dialog_delete: false,
      dialog_copy: false,
      dialog_status: false,
      order_data: undefined,
      edit_status: undefined,
      dialog_status_text: "",
      error_text: {
        error: false,
        text: ""
      },
      not_formed_orders: true,
      search: {
        parameter: "search"
      },
      pagination: {
        filters: {
          "order_type": null,
          "order_status": null,
          "start_date": null,
          "end_date": null
        }
      },
      choices: {
        order_type: [],
        order_status: []
      },
      headers: [
        {text: "Номер", value: "through_number", sortable: true, align: "start" , width: "8%"},
        {text: "Тип пропуска", value: "order_type", sortable: false, align: "start" , width: "17%"},
        {text: "Ответственный", value: "responsible", sortable: true, align: "start", width: "10%"},
        {text: "Посетитель", value: "visitors", sortable: true, align: "start", width: "13%"},
        {text: "Дата начала", value: "start_date", sortable: true, align: "center", width: "10%"},
        {text: "Дата окончания", value: "end_date", sortable: true, align: "center", width: "10%"},
        {text: "Статус", value: "status", sortable: false, align: "center", width: "10%"},
        {text: "Изменение статуса", value: "last_update", sortable: true, align: "center", width: "12%"},
        {text: "Действия", value: "actions", sortable: false, align: "center", width: "16%"}
      ]
    }
  },
  watch: {
  },
  computed:{
    ...mapGetters({
      items: "representative/getOrdersList",
      count: "representative/getOrdersCount",
      isLoading: "representative/isLoadingOrders",
      isNotFormedOrders: "representative/isNotFormedOrders",
      getCurrentUrl: "representative/getOrdersCurrentUrl",
      limits: "representative/getOrdersLimits"
    }),
    extensionHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 170
      } else {
        return 0
      }
    }
  },
  methods: {
    ...mapActions({
      loadOrdersList: "representative/loadOrdersList",
      deleteOrders: "representative/deleteOrders",
      copyOrders: "representative/copyOrders",
      formalizeOrders: "representative/formalizeOrders",
      withDrawOrders: "representative/withdrawOrders",
      annulOrders: "representative/annulOrders",
      loadOrdersLimits: "representative/loadOrdersLimits",
      loadOrderTypeChoices: "choices/loadOrderTypeChoices",
      loadOrderStatusChoices: "choices/loadOrderStatusChoices"
    }),
    displayDate: displayDate,
    getDetail(item) {
      this.$router.push({name: names.ORDERS.DETAIL, params: {idOrders: item.id}}).catch(() => {})
    },
    updateData(){
      if (this.search.value) {
        this.search.value = ""
      }
      this.pagination.filters = {
        "order_type": null,
        "order_status": null
      }
      this.loadData()
    },
    loadData(url=undefined){
      this.loadOrdersList({
        url: url,
        urlAppend: (url) => {
          let new_url = this.addPageParameter(this.addSizeParameter(url))
          if (this.search.value)
            new_url = this.addGetParameter(new_url, "search", this.search.value)
          if (this.pagination.filters.order_type)
            new_url = this.addGetParameter(new_url, "order_type", this.pagination.filters.order_type)
          if (this.pagination.filters.order_status)
            new_url = this.addGetParameter(new_url, "order_status", this.pagination.filters.order_status)
          // new_url = this.addGetParameter(new_url, "start_date", new Date().toISOString().split("T")[0])
          return new_url
        },
        finalizer: (data, url) => {
          // if (url.toString().includes("start_date")) {
          //   this.pagination.filters.start_date = new Date().toISOString().split("T")[0]
          // }
          this.setCurrentLoadUrl(url);
        }
      })
    },
    loadLimits(url=undefined) {
      this.loadOrdersLimits({
        url: url
      })
    },
    closeNotFormedOrdersDialog() {
      this.not_formed_orders = false
      window.$cookies.remove("notFormedOrders",null);
      let date = new Date()
      date.setMinutes(date.getMinutes() + 15,  0, 0)
      window.$cookies.set(
          "notFormedOrders",
          null,
          date,
          null,
          null,
          null
      );
    },
    newOrder() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.order_data = undefined
    },
    editOrder(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.order_data = item
    },
    deleteOrder(item) {
      this.dialog_delete = true
      this.order_data = item
    },
    copyOrder(item) {
      this.dialog_copy = true
      this.order_data = item
    },
    changeOrderStatus(item) {
      this.dialog_status_text = this.checkEditFlag(item).form
      this.dialog_status = true
      this.order_data = item
    },
    closeEditDialog(event) {
      if (event.order_type === 1 || event.order_type === 4) {
        this.changeOrderStatus(event)
      } else {
        this.loadData()
        this.dialog_add_edit = false
        this.order_data = undefined
      }
    },
    closeDeleteDialog(event) {
      if(event){
        this.deleteOrders({
          id: this.order_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher:(val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.order_data = undefined
    },
    closeCopyDialog(event) {
      if(event) {
        this.copyOrders({
          id: this.order_data.id,
          finalizer: (val) => {
            this.loadData()
            // Автоматическое открытие детали и формы редактирования при копировании заявки
            this.$router.push({name: names.ORDERS.DETAIL, params: {idOrders: val.id}, query: {edit: "true"}}).catch(() => {})
          },
          catcher:(val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_copy = false
      this.order_data = undefined
    },
    closeStatusDialog(event) {
      if(event) {
        this.error_text.error = false
        // Сформировать заявку
        if (!this.order_data.is_formalized) {
          this.dialog_add_edit = false

          this.formalizeOrders({
            id: this.order_data.id,
            data: { "is_formalized": true },
            finalizer: (val) => {
              this.loadData()
            },
            catcher:(val) => {
              this.error_text.error = true
              this.error_text.text = String(val.detail)
            }
          })
        // Расформировать заявку
        } else if (this.order_data.is_formalized && this.order_data.is_agreed === null) {
          this.formalizeOrders({
            id: this.order_data.id,
            data: { "is_formalized": false },
            finalizer: (val) => {
              this.loadData()
            },
            catcher:(val) => {
              this.error_text.error = true
              this.error_text.text = String(val.detail)
            }
          })
        // Аннулировать заявку
        } else if (this.order_data.allowed_annul && !this.order_data.is_annul) {
          this.annulOrders({
            id: this.order_data.id,
            data: {},
            finalizer: (val) => {
              this.loadData()
            },
            catcher:(val) => {
              this.error_text.error = true
              this.error_text.text = String(val.detail)
            }
          })
        // Отозвать заявку
        } else {
          this.withDrawOrders({
            id: this.order_data.id,
            data: {},
            finalizer: (val) => {
              this.loadData()
            },
            catcher:(val) => {
              this.error_text.error = true
              this.error_text.text = String(val.detail)
            }
          })
        }
      }
      if (this.order_data.order_type === 1 && !event || this.order_data.order_type === 4 && !event) {
        this.dialog_add_edit = false
        this.loadData()
      }
      this.dialog_status = false
      this.order_data = undefined
    },
    // Функция возвращает текстовое значение статуса в зависимоти от состояния заявки
    order_status (item) {
      if (item.is_formalized && item.is_agreed === null && !item.automate_annul) {
        return "Оформлена"
      } else if (item.is_withdrawn) {
        return "Отозвана"
      } else if (item.is_agreed && item.is_formalized && !item.is_annul) {
        return "Согласована"
      } else if (item.is_agreed === false && item.is_formalized) {
        return "Отклонена"
      } else if (item.is_agreed === true && item.is_annul || item.automate_annul) {
        return "Аннулирована"
      } else {
        return "Создана"
      }
    },
    orderTextStatus (item) {
      if (item.is_formalized && item.is_agreed === null && !item.automate_annul) {
        return "Заявка направлена на рассмотрение Согласующему"
      } else if (item.is_withdrawn) {
        return "Заявка на оформление пропуска отозвана заявителем"
      } else if (item.is_agreed && item.is_formalized && !item.is_annul) {
        return "Заявка подтверждена и согласована"
      } else if (item.is_agreed === false && item.is_formalized) {
        return "Заявка на оформление пропуска отклонена Согласующим"
      } else if (item.is_agreed === true && item.is_annul || item.automate_annul) {
        return "Заявка аннулирована администрацией сервиса"
      } else {
        return "Заявка создана, но не отправлена на рассмотрение"
      }
    },
    orderTypeIcons (item) {
      if (String(item.order_type) === "Разовый") {
        return "today"
      } else if (String(item.order_type) === "Временный") {
        return "calendar_month"
      } else if (String(item.order_type) === "Массовый") {
        return "groups"
      } else if (String(item.order_type) === "Автомобильный разовый") {
        return "directions_bus"
      } else if (String(item.order_type) === "Автомобильный временный") {
        return "departure_board"
      } else {
        return "confirmation_number"
      }
    },
    // Функция для отображения разных иконок в зависимости от статуса заявки
    checkEditFlag(item) {
      if (item.is_agreed && !item.allowed_annul && !item.is_annul) return {icon: "highlight_off", text: "Отозвать согласованную заявку", form: "Вы уверены, что хотите отозвать данную заявку?"}
      else if (item.is_agreed === null && item.is_formalized) return {icon: "undo", text: "Отозвать заявку", form: "Вы уверены, что хотите расформировать данную заявку?"}
      else if (item.allowed_annul  && !item.is_annul) return {icon: "unpublished", text: "Аннулировать заявку", form: "Вы уверены, что хотите аннулировать данную заявку?"}
      else return {icon: "redo", text: "Отправить на согласование", form: "Вы уверены, что хотите сформировать данную заявку и отправить ее на согласование?"}
    },
    loadChoices() {
      this.loadOrderTypeChoices({
        url: undefined,
        finalizer: (val) => {
          this.choices.order_type = val
        }
      })
      this.loadOrderStatusChoices({
        url: undefined,
        finalizer: (val) => {
          this.choices.order_status = val
        }
      })
    }
  },
  created() {
    if (window.$cookies.get("notFormedOrders")) {
      this.not_formed_orders = false
    }

    if(representative.REPRESENTATIVE.ALLOWED()){
      this.loadLimits()
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
      this.loadChoices()
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }

}

</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
